/**
 * PubSub actions
 *
 * Actions originated by pubsubs messages. This can be formData updates etc.
 * These actions are consumed in normal reducers, we use a special actions as this should not be handled by redux-sagas
 *
 */

import {
  PUBSUB3_FORMDATA_UPDATE,
  PUBSUB3_NOTIFICATION_CREATE,
} from "../constants";

/**
 * pubsub3FormDataUpdate
 *
 * @param {objectId} formDataId - formDataId of document to fectch
 * @param {string} value - value
 * @param {objectId/string} key - value
 * @param {array} data - data
 */
export const pubsub3FormDataUpdate = ({ formDataId, value, key, data }) => {
  return {
    type: PUBSUB3_FORMDATA_UPDATE,
    formDataId,
    value,
    key,
    data,
  };
};

/**
 * pubsubpubsub3NotificationCreate3FormDataUpdate
 *
 * @param {objectId} formDataId - formDataId of document to fectch
 * @param {string} value - value
 * @param {objectId/string} key - value
 * @param {array} data - data
 */
export const pubsub3NotificationCreate = (payload) => {
  return {
    type: PUBSUB3_NOTIFICATION_CREATE,
    payload,
  };
};
